var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GetFile',{attrs:{"loader":_vm.loader,"asLink":true,"with-title":false},on:{"get-file":function($event){return _vm.getQRCode()}}},[_c('template',{slot:"icon"},[_c('HintingIcon',{attrs:{"icon":_vm.ICONS.QR_CODE,"class-name":"mr-2","tooltip":_vm.$t('management.customers_and_sites.actions.qr')}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }